import { gql } from "@apollo/client";

export type SendReservationInquiryEmailInput = {
  groupVenueId: string;
  body: string;
};

export type SendReservationInquiryEmailResponse = {
  sendReservationInquiryEmail: boolean;
};

export const SEND_RESERVATION_INQUIRY_EMAIL_MUTATION = gql`
  mutation SendReservationInquiryEmailMutation(
    $groupVenueId: ID!
    $body: String!
  ) {
    sendReservationInquiryEmail(groupVenueId: $groupVenueId, body: $body)
  }
`;
